import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { LayoutType } from '../constants/LayoutConstants';
import { ViewSettingsStore } from '../stores/ViewSettingsStore';
import { SceneStore } from '../stores/SceneStore';
import { InteractorContainer } from './InteractorContainer';

interface ViewContainerProps {
    view: Element;
}

interface ViewContainerState {
    visible: boolean;
    layoutType: LayoutType;
}

export class ViewContainer extends BaseComponent<ViewContainerProps, ViewContainerState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(SceneStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.state.visible) {
            return null;
        }

        return (
            <div className="viewcontainer">
                <InteractorContainer />
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            visible: this.props.view === SceneStore.getState().activeView,
            layoutType: ViewSettingsStore.getState().layoutType
        });
    };

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ViewContainer.tsx